import React, { useState } from "react";

export default function UserCentralFeed() {
 
  const [activeTab, setActiveTab] = useState("active");
  const [selectedCategory, setSelectedCategory] = useState("All");

  const categories = [
    "All",
    "Cafes",
    "Hotels",
    "Salons",
    "Restaurants",
  ];

  const coupons = [
    {
      id: 1,
      title: "20% OFF Coffee",
      brand: "Cafe Mocha",
      type: "Cafes",
      status: "active",
      icon: "☕",
      location: "Delhi",
    },
    {
      id: 2,
      title: "Free Pizza Slice",
      brand: "Pizza Hub",
      type: "Restaurants",
      status: "expired",
      icon: "🍕",
      location: "Mumbai",
    },
    {
      id: 3,
      title: "Hair Spa Discount",
      brand: "Royal Salon",
      type: "Salons",
      status: "active",
      icon: "💇",
      location: "Jaipur",
    },
    {
      id: 4,
      title: "Free Mocktail",
      brand: "Sky Hotel",
      type: "Hotels",
      status: "expired",
      icon: "🏨",
      location: "Chandigarh",
    },
  ];

  const filteredCoupons = coupons.filter((item) => {

    const categoryMatch =
      selectedCategory === "All"
        ? true
        : item.type === selectedCategory;

    const statusMatch = item.status === activeTab;

    return categoryMatch && statusMatch;

  });

  return (
    <>
      <style>{`

        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
          font-family:'Poppins',sans-serif;
        }

        body{
          background:#f5f7fb;
        }

        .feed-page{
          min-height:100vh;
          padding:35px;
          background:
          linear-gradient(135deg,#fff7ed,#fff,#eef4ff);
        }

        /* HEADER */

        .top-header{
          display:flex;
          justify-content:space-between;
          align-items:center;
          flex-wrap:wrap;
          gap:20px;
          margin-bottom:35px;
        }

        .user-info h1{
          font-size:42px;
          color:#111827;
          font-weight:800;
          margin-bottom:8px;
        }

        .user-info p{
          color:#6b7280;
          font-size:16px;
        }

        .profile{
          width:70px;
          height:70px;
          border-radius:50%;
          background:
          linear-gradient(135deg,#ff8c42,#ff5e62);
          color:white;
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:28px;
          font-weight:700;
          box-shadow:0 15px 30px rgba(255,94,98,0.3);
        }

        /* ANALYTICS */

        .analytics{
          background:white;
          border-radius:35px;
          padding:40px;
          box-shadow:0 15px 45px rgba(0,0,0,0.06);
          margin-bottom:35px;
          position:relative;
          overflow:hidden;
        }

        .analytics::before{
          content:'';
          position:absolute;
          width:240px;
          height:240px;
          background:rgba(255,140,66,0.08);
          border-radius:50%;
          right:-80px;
          top:-100px;
        }

        .analytics h2{
          font-size:34px;
          color:#111827;
          margin-bottom:15px;
        }

        .analytics p{
          color:#6b7280;
          font-size:18px;
          line-height:1.8;
        }

        .stats{
          display:grid;
          grid-template-columns:repeat(auto-fit,minmax(220px,1fr));
          gap:25px;
          margin-top:35px;
        }

        .stat-card{
          background:#fff7ed;
          border-radius:28px;
          padding:30px;
          transition:0.3s;
        }

        .stat-card:hover{
          transform:translateY(-6px);
        }

        .stat-card h3{
          font-size:42px;
          color:#ff6b35;
          margin-bottom:10px;
        }

        .stat-card p{
          color:#6b7280;
          font-size:16px;
        }

        /* FILTER */

        .filter-section{
          margin-bottom:35px;
        }

        .filter-title{
          font-size:24px;
          color:#111827;
          margin-bottom:20px;
          font-weight:700;
        }

        .filters{
          display:flex;
          gap:15px;
          flex-wrap:wrap;
        }

        .filter-btn{
          padding:14px 25px;
          border:none;
          border-radius:18px;
          background:white;
          color:#555;
          font-size:15px;
          font-weight:700;
          cursor:pointer;
          transition:0.3s;
          box-shadow:0 5px 20px rgba(0,0,0,0.05);
        }

        .filter-btn.active{
          background:
          linear-gradient(135deg,#ff8c42,#ff5e62);
          color:white;
        }

        /* MAP */

        .map-box{
          background:white;
          border-radius:35px;
          padding:35px;
          margin-bottom:35px;
          box-shadow:0 10px 35px rgba(0,0,0,0.05);
        }

        .map-box h2{
          font-size:30px;
          margin-bottom:25px;
          color:#111827;
        }

        .city-grid{
          display:grid;
          grid-template-columns:repeat(auto-fit,minmax(180px,1fr));
          gap:20px;
        }

        .city-card{
          background:#f9fafb;
          border-radius:24px;
          padding:25px;
          text-align:center;
          transition:0.3s;
        }

        .city-card:hover{
          transform:translateY(-5px);
          background:#fff7ed;
        }

        .city-card span{
          font-size:42px;
          display:block;
          margin-bottom:15px;
        }

        .city-card h3{
          font-size:20px;
          margin-bottom:8px;
          color:#111827;
        }

        .city-card p{
          color:#6b7280;
        }

        /* COUPONS */

        .coupon-section{
          margin-top:20px;
        }

        .coupon-tabs{
          display:flex;
          gap:15px;
          margin-bottom:30px;
          flex-wrap:wrap;
        }

        .tab-btn{
          padding:15px 28px;
          border:none;
          border-radius:18px;
          background:white;
          color:#555;
          font-size:16px;
          font-weight:700;
          cursor:pointer;
          transition:0.3s;
          box-shadow:0 5px 20px rgba(0,0,0,0.05);
        }

        .tab-btn.active{
          background:
          linear-gradient(135deg,#ff8c42,#ff5e62);
          color:white;
        }

        .coupon-grid{
          display:grid;
          grid-template-columns:repeat(auto-fit,minmax(320px,1fr));
          gap:25px;
        }

        .coupon-card{
          background:white;
          border-radius:30px;
          padding:30px;
          box-shadow:0 10px 35px rgba(0,0,0,0.05);
          transition:0.3s;
          position:relative;
          overflow:hidden;
        }

        .coupon-card:hover{
          transform:translateY(-8px);
        }

        .coupon-top{
          display:flex;
          justify-content:space-between;
          align-items:center;
          margin-bottom:20px;
        }

        .coupon-icon{
          width:70px;
          height:70px;
          border-radius:24px;
          background:#fff4eb;
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:38px;
        }

        .status{
          padding:10px 16px;
          border-radius:30px;
          font-size:13px;
          font-weight:700;
          text-transform:capitalize;
        }

        .status.active{
          background:#ecfdf5;
          color:#059669;
        }

        .status.expired{
          background:#fee2e2;
          color:#dc2626;
        }

        .coupon-card h3{
          font-size:28px;
          color:#111827;
          margin-bottom:10px;
        }

        .coupon-card p{
          color:#6b7280;
          line-height:1.8;
          margin-bottom:10px;
        }

        .location{
          margin-top:18px;
          display:inline-block;
          background:#f3f4f6;
          padding:10px 18px;
          border-radius:30px;
          font-size:14px;
          font-weight:600;
          color:#374151;
        }

        @media(max-width:768px){

          .feed-page{
            padding:20px;
          }

          .user-info h1{
            font-size:30px;
          }

          .analytics{
            padding:30px 25px;
          }

          .analytics h2{
            font-size:28px;
          }

          .coupon-card h3{
            font-size:22px;
          }

        }

      `}</style>

      <div className="feed-page">

        {/* HEADER */}

        <div className="top-header">

          <div className="user-info">

            <h1>
              Welcome Back, Sonu 👋
            </h1>

            <p>
              Your loyalty journey across all restaurants & brands
            </p>

          </div>

          <div className="profile">
            S
          </div>

        </div>

        {/* ANALYTICS */}

        <div className="analytics">

          <h2>
            Global Visits Analytics
          </h2>

          <p>
            Track all your restaurant visits, rewards,
            coupons and loyalty achievements from one place.
          </p>

          <div className="stats">

            <div className="stat-card">

              <h3>
                12
              </h3>

              <p>
                Restaurants Visited
              </p>

            </div>

            <div className="stat-card">

              <h3>
                5
              </h3>

              <p>
                Rewards Claimed
              </p>

            </div>

            <div className="stat-card">

              <h3>
                28
              </h3>

              <p>
                Total Visits
              </p>

            </div>

          </div>

        </div>

        {/* FILTERS */}

        <div className="filter-section">

          <h2 className="filter-title">
            Filter By Category
          </h2>

          <div className="filters">

            {categories.map((item) => (

              <button
                key={item}
                className={`filter-btn ${
                  selectedCategory === item
                  ? "active"
                  : ""
                }`}
                onClick={() =>
                  setSelectedCategory(item)
                }
              >
                {item}
              </button>

            ))}

          </div>

        </div>

        {/* CITY MAP */}

        <div className="map-box">

          <h2>
            Your Market Footprints 🌍
          </h2>

          <div className="city-grid">

            <div className="city-card">
              <span>☕</span>
              <h3>Delhi</h3>
              <p>4 Cafes Visited</p>
            </div>

            <div className="city-card">
              <span>🍕</span>
              <h3>Mumbai</h3>
              <p>3 Restaurants</p>
            </div>

            <div className="city-card">
              <span>🏨</span>
              <h3>Jaipur</h3>
              <p>2 Hotels</p>
            </div>

            <div className="city-card">
              <span>💇</span>
              <h3>Chandigarh</h3>
              <p>3 Salons</p>
            </div>

          </div>

        </div>

        {/* COUPONS */}

        <div className="coupon-section">

          <div className="coupon-tabs">

            <button
              className={`tab-btn ${
                activeTab === "active"
                ? "active"
                : ""
              }`}
              onClick={() =>
                setActiveTab("active")
              }
            >
              Active Coupons
            </button>

            <button
              className={`tab-btn ${
                activeTab === "expired"
                ? "active"
                : ""
              }`}
              onClick={() =>
                setActiveTab("expired")
              }
            >
              Expired Coupons
            </button>

          </div>

          {/* COUPON GRID */}

          <div className="coupon-grid">

            {filteredCoupons.map((item) => (

              <div
                key={item.id}
                className="coupon-card"
              >

                <div className="coupon-top">

                  <div className="coupon-icon">
                    {item.icon}
                  </div>

                  <div
                    className={`status ${item.status}`}
                  >
                    {item.status}
                  </div>

                </div>

                <h3>
                  {item.title}
                </h3>

                <p>
                  Brand: {item.brand}
                </p>

                <p>
                  Category: {item.type}
                </p>

                <div className="location">
                  📍 {item.location}
                </div>

              </div>

            ))}

          </div>

        </div>

      </div>
    </>
  );
}